
    
  import React, { useReducer } from "react";
  import axios2 from 'services/axios2';

  import {useParams} from "react-router-dom";
  import {Link,hashHistory} from 'react-router-dom';
  import { ToastContainer, toast } from 'react-toastify';
  import { NuDropdown } from "components/nubox/NuDropdown";

  import ImageUpload from "components/nubox/ImageUpload";
  import NuConfirm from "components/nubox/Box/NuConfirm";
  import { withRouterJim } from "router/withRouterJim";
  
  import Box_buscar_materia from 'views/_box/Box_buscar_materia'; 
  import BoxBuscarMatXNivel from 'views/_box/BoxBuscarMatXNivel'; 
  

  import user2 from "assets/img/user2.png"
  import { NotificationContainer, NotificationManager } from 'react-notifications';
  import {
    Table,
    Button,
    Container,
    Modal,
    ModalHeader,
    ModalBody,
    FormGroup,
    ModalFooter,
    ToastHeader,
  } from "reactstrap";

  const cbo=[
    {  value:'1', label: 'label1'},
  ]
  
  const initialForm={
    id_u:'',
    nro_doc:'',
    nomape_tmp:'',
    dir:'',
    tel:'',
    foto_path1:'',
    estado:0,
  }
  //$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
  class ProgramarMat extends React.Component {
    modalRef = React.createRef();//create ref

    state = {
      modalInsertar: false, //box materia
      modalBuscarMat:false,

      materia_selected:{}, //seleccionada del box

      modalImagen: false,
      id_est:0,  //desde parametros
      id_peri:0,  //desde parametros
      
      form: Object.assign({}, initialForm),
        
      data: [],/* tabla  */
      
    };
    //--------------------------------------
    constructor(props) {
      super(props);

      this.refNuConfirm = React.createRef();
    }
    //------------------
    //---------------------------------
    componentDidMount() {
      //--limpiamos el array de prueba
      this.setState({data:[]});
  
      // Get the userId param from the URL.
      //let id_est = this.props.params.id;
      //let id_peri = this.props.store.user.id_peri;

      let id_est = this.props.store.user.id_est
      let id_peri = this.props.store.user.id_peri
            
      this.cargar_estudiante(id_est); //carga datos del estudiante
      this.cargar_data(id_est, id_peri); //carga del periodo de el store
            
      //---actualizamos el estado
      this.setState({id_est: id_est, id_peri: id_peri})
    }
    //----------------especial, actualiza valores del form -------------------------------
    handleChangeForm = (e) => {
      //requerimos la prop name='?' en cada control
      
      //--- esto lo hacemos porque en vez de utilizar valores true, false
      //--- tenemos que utilizar 1, 0
      if(e.target.type==="checkbox"){

        let res = e.target.checked? 1:0;        
        this.setState({
          form:{
            ...this.state.form,
            [e.target.name]: res,
          }
        })
      }else{
        this.setState({
          form: {
            ...this.state.form,
            [e.target.name]: e.target.value,
          },
        });
      }
    };
    //-----------------------------------------
    cargar_estudiante = (id_est) => {      
      console.log("cargar_estudiante");
      let param = { 
        id_est: id_est,
      }
      console.log(param);
      axios2.post( "programacion_buscar_est", param)
      .then(res => {
          console.log(res.data);
          if( res.data!==''){ 
              //cargamos el estudiante
              this.setState({
                form: {  ...res.data,  },
              });
              
          }else{
            toast.error("Registro no encontrado", {
              position: toast.POSITION.TOP_RIGHT
            });
          }
  
      }).catch(error => {
          alert("---- Existio un error ---");
          console.log(error);
      });
    };
    //---carga la programacion del estudiante
    cargar_data = (id_est, id_peri) => {      
  
      let param = { 
        id_est: id_est,
        id_peri: id_peri,
      }
      console.log(param);
      axios2.post( "programacion_get_programacion", param)
      .then(res => {
          console.log(res.data);
          if( res.data!==''){ 
              //cargamos el estudiante
              this.setState({  data: res.data  });
              
          }else{
            toast.error("Registro no encontrado", {
              position: toast.POSITION.TOP_RIGHT
            });
          }
  
      }).catch(error => {
          alert("---- Existio un error ---");
          console.log(error);
      });
    };

    //-------------------MODAL----------------------------------------------
    editar = (item) =>{
      console.log('editar');
      //    console.log(item);
      let idd = item.id_progra;
      this.modalRef.current.editar(idd);
    }
    //-----------------------------------------------------------------
    eliminar = (item) =>{
      console.log('eliminar');
      
      this.refNuConfirm.current.show({
        message: 'Esta seguro de eliminar?',
        title: 'Confirmar',
        icon: 'fa fa-question-circle',
        classHeader: 'bg-default1 ',
        classButton: 'btn btn-danger',
        accept: () => {
          let idd = item.id_progra;
          this.modalRef.current.eliminar(idd);
        },
        reject: () => {
            console.log('cancel');
        },
        acceptLabel: 'Aceptar',
        rejectLabel: 'Cancelar'
      })
  
    }
    //-------------------------------------
    okModal =()=>{
      console.log('citaOkModal');
      
      this.cargar_data( this.state.id_est, this.state.id_peri);
    }
    //-------------------------------------
    closeModal =()=>{
      console.log('citaCancelModal');
    }
    //-------------
    handleSubmit = event => {
      event.preventDefault();
      this.cargar_form();
    }

    //------------------ BOX materias x cliente----------------------------
    toggle1 = () =>{ this.setState({modalBuscarMat: !this.state.modalBuscarMat })}
    
    handleClickBoxMateXMat=(item)=>{
      //alert ("click" );
      //---lo ocultamos
      this.toggle1();
      //---------
      //---------grabamos la materia a la programacion del estudiante
      //this.saveNew( item );
      //ahora asignamos los valores
      //this.setState({ materia_selected: item });
    }
    buscar_materias_x_nivel_click =()=>{
      this.toggle1();
    }
    //-----------------------------------------------

    //------------------ BOX CLIENTE----------------------------
    toggle = () =>{ this.setState({modalInsertar: !this.state.modalInsertar})}

    handleClickBoxMate=(item)=>{
      //alert ("click" );
      //---lo ocultamos
      this.toggle();
      //---------
      //---------grabamos la materia a la programacion del estudiante
      this.saveNew( item );
      //ahora asignamos los valores
      this.setState({ materia_selected: item });
    }
    buscar_materia_click =()=>{
      this.toggle();
    }
    //-----------------------------------------------
    aceptar_click = async () => {
      console.log("aceptar");
      this.save();
      
    }
    //----------------------------
    saveNew =(item) =>{    
      let param =  { id_peri: this.state.id_peri ,
                     id_carre: 1, 
                     id_est: this.state.id_est,	
                     id_mate: item.id_mate};
      console.log(param);

      axios2.post("programacion_savenew", param)
      .then(res => {
          if(res.data.exito === 1){ 
              toast.success(res.data.mensaje);
              //--- tenemos que redireccionar
              this.cargar_data(this.state.id_est, this.state.id_peri);
              //this.props.navigate('/DocenteList');
          }else{
              toast.error(res.data.mensaje);
          }
  
      }).catch(error => {
          alert("---- Existio un error ---");
          console.log(error);
          
      });
    
    }
    
    //------------------------------
    render() {
      let user = this.props.store.user
      return (
        <div>
          <ToastContainer />
          <div className="content">

            {/* ---   --- */}
            <section className="content-header">
              <div className="" style={{ textAlign:'center' }}>
                <h3 className="text-muted">Programar materias</h3>
              </div>
              {/**/}

              Gestión:  {user.periodo}

         
          </section>


            <section className="content">
              <h5 className="text-bold">
                Programacion 
              </h5>
              
              <button className="btn  btn-success" 
                      onClick={(e)=> this.buscar_materia_click(e)} >
                <i className="fa fa-plus"></i> Agregar materia
              </button>

              <button className="btn  btn-info" 
                      onClick={(e)=> this.buscar_materias_x_nivel_click(e)} >
                <i className="fa fa-plus"></i> Agregar materias por nivel
              </button>
              
              <div className="col-md-10">
                <div className="card">

                  <div className="card-body">
                    {/*-- */}
                    <div className="row">
                      <table className='table table-striped table-hover' width='100%' align='center'>
                        <thead>

                          <tr>
                            <th>Nro.</th>
                            <th>Sigla</th>
                            <th>Materia</th>
                            <th>Grupo</th>
                            <th>Accion</th>
                          </tr>

                        </thead>
                        <tbody>
                          {/* className='text-left' */}

                          {this.state.data.map((item, index) => (
                            <tr key={index}>
                             
                              <td>{item.id_progra}</td>
                              <td>{item.sigla}</td>
                              <td>{item.nombre}</td>
                              <td>{item.id_grupo}</td>

                              <td>
                                {/*
                                <div className='btn-group'>
                                  <Button className='btn btn-warning btn-sm' title='Editar'
                                    onClick={() => this.editar(item)}>
                                    <i className='fa fa-edit'></i>
                                  </Button>
                                  &nbsp;
                                  <Button className='btn btn-danger btn-sm' title='Eliminar'
                                    onClick={() => this.eliminar(item)}  >
                                    <i className='fa fa-trash'></i>
                                  </Button>
                                </div>
                                 */}
                              </td>
                            </tr>
                          ))}



                        </tbody>
                      </table>
                    </div>
                    {/*-- */}



                  </div>

                  <div className="card-footer">
                    <div className="form-group">
                      <div className="text-center">
                        {/*<Button onClick={this.aceptar_click} className="btn btn-primary">
                          <i className="fa fa-floppy-o"></i>&nbsp;
                          Guardar
                        </Button>
                        &nbsp;
                        <Link to='/DocenteList' className="btn btn-default">Volver</Link>
                          */}
                      </div>
                    </div>
                  </div>

                </div>
              </div>

              <div className="col-md-2">

              </div>
            </section>
          </div>

          <Box_buscar_materia
            modalOpen={this.state.modalInsertar}
            toggle={this.toggle}
            hancleClick={this.handleClickBoxMate}
          />

          <BoxBuscarMatXNivel
            modalOpen={this.state.modalBuscarMat}
            toggle={this.toggle}
            hancleClick={this.handleClickBoxMateXNivel}
          />

          

          <NuConfirm   ref={ this.refNuConfirm }    />
        </div>
      );
    }
  }
    
  //------------para que soporte la funcionalidad de parametros
  export default withRouterJim(ProgramarMat);